"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.title,
      width: "400px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c("div", {
          staticClass: "footer"
        }, [_c("div", [_vm.checkedDepartment ? _c("div", [_vm._v("已选择：" + _vm._s(_vm.checkedDepartment.name))]) : _vm.checkedUser ? _c("div", {
          staticClass: "checked-user"
        }, [_c("div", [_vm._v("已选择：")]), _c("div", [_c("div", [_vm._v(_vm._s(_vm.checkedUser.userName))]), _c("div", [_vm._v(_vm._s(_vm.checkedUser.deptName))])])]) : _vm._e()]), _c("span", [_c("a-button", {
          on: {
            click: function ($event) {
              _vm.modelVisible = false;
            }
          }
        }, [_vm._v("取消")]), _c("a-button", {
          attrs: {
            loading: _vm.loading,
            type: "primary"
          },
          on: {
            click: _vm.handleConfirmClick
          }
        }, [_vm._v("确定")])], 1)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modelVisible,
      callback: function ($$v) {
        _vm.modelVisible = $$v;
      },
      expression: "modelVisible"
    }
  }, [_c("a-input-search", {
    staticClass: "mb-[10px]",
    attrs: {
      placeholder: "请输入用户名搜索"
    },
    model: {
      value: _vm.keyWord,
      callback: function ($$v) {
        _vm.keyWord = $$v;
      },
      expression: "keyWord"
    }
  }), _c("div", {
    staticClass: "layout"
  }, [!_vm.keyWord ? _c("DepartmentTree", {
    attrs: {
      "permission-check": _vm.departmentPermissionCheck,
      "show-select": _vm.departmentSelect,
      "department-tree": _vm.renderDepartmentTree,
      "current-department": _vm.currentDepartment
    },
    on: {
      "update:currentDepartment": function ($event) {
        _vm.currentDepartment = $event;
      },
      "update:current-department": function ($event) {
        _vm.currentDepartment = $event;
      },
      change: _vm.handleDepartmentChange
    },
    model: {
      value: _vm.checkedDepartmentId,
      callback: function ($$v) {
        _vm.checkedDepartmentId = $$v;
      },
      expression: "checkedDepartmentId"
    }
  }) : _vm._e(), !_vm.keyWord ? _c("a-divider") : _vm._e(), _vm.userSelect ? _c("UserList", {
    attrs: {
      "only-self-user": _vm.onlySelfUser,
      "all-user": _vm.allUser,
      "key-word": _vm.keyWord,
      "department-tree": _vm.renderDepartmentTree,
      "department-id": _vm.currentDepartment?.id
    },
    on: {
      change: _vm.handleUserChange
    },
    model: {
      value: _vm.checkedUserId,
      callback: function ($$v) {
        _vm.checkedUserId = $$v;
      },
      expression: "checkedUserId"
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;